<template>
  <div>
    <div class="header">
      <slot name="header" />
    </div>
    <LineChart :id="id" :chartData="chartData.datas" :chartOptions="options" :ref="`chart${id}`" :height="height" />
    <div v-if="!hideScoreDiff">
      <div v-show="scoreDiffs.length > 0" class="diff-title">
        <FieldLabel title="最新との差分" :required="false" style="width: auto;" />
        <HelpIcon tooltipText="最新の受検結果との差分を表示しています" position="top-left" cls="uk-active uk-width-auto" />
      </div>
      <div>
        <table class="diff" rules="all">
          <tbody>
            <tr v-for="(diffs, i) in scoreDiffs" :key="i">
              <td width="12px">
                <div class="box" id="makeImg" :style="'background: ' + graphColors[i + 1] + ' !important'"></div>
              </td>
              <td v-for="(score, j) in diffs" :key="j" :class="score >= 10 || score <= -10 ? 'red' : ''">
                {{ score }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
.header {
  font-size: 32px;
  margin: 6px 0;
}
.diff-title {
  display: flex;
}
.diff {
  table-layout: fixed;
  border-collapse: collapse;
  border: solid 1px #000000;
  width: 100.5%;
  min-width: 900px;
  td {
    text-align: center;
    font-size: 12px;
  }
  .box {
    margin: auto;
    width: 8px;
    height: 8px;
  }
  .red {
    color: red !important;
    font-weight: bold;
    border-color: #666;
  }
}
</style>
<script lang="ts">
import { Prop, Watch } from "vue-property-decorator";
import { Options } from "vue-class-component";
import LineChart from "../molecules/LineChart.vue";
import FieldLabel from "../atoms/FieldLabel.vue";
import HelpIcon from "../atoms/HelpIcon.vue";
import { ChartData, GraphData } from "../pages/Progress.vue";
import { GraphColors } from "../../helpers/const";
import ChartMixin from "../../helpers/mixins/chart";
import { ChartOptions } from "chart.js";

@Options({
  components: {
    LineChart,
    FieldLabel,
    HelpIcon
  }
})
export default class ProgressChart extends ChartMixin {
  @Prop({ required: true, type: String }) id?: string;
  @Prop({ required: true, type: Object }) chartData?: ChartData;
  @Prop({ required: true, type: Object }) options?: ChartOptions;
  @Prop({ type: Object }) height: number | string = "auto";
  @Prop({ required: true, type: Boolean }) hideScoreDiff: boolean = false;
  scoreDiffs: number[][] = [];

  get graphColors() {
    return GraphColors;
  }
  rerenderChart() {
    (this.$refs[`chart${this.id}`] as LineChart).rerenderChart();
  }
  @Watch("chartData.datas", { deep: true, immediate: true })
  updateScoreDiffs() {
    this.scoreDiffs = [];
    if (!this.chartData || this.chartData.examDate.length <= 1 || this.hideScoreDiff) {
      return;
    }
    const latestDate = this.chartData.examDate.sort((a, b) => (a > b ? -1 : 1))[0];
    const latestDataset = (this.chartData.datas as GraphData).datasets.find(dataset => dataset.label.includes(latestDate));
    const comparingDatasets = (this.chartData.datas as GraphData).datasets.filter(dataset => !dataset.label.includes(latestDate));

    comparingDatasets.map((dataset, i) => {
      this.scoreDiffs.push([]);
      dataset.data.forEach((score, j) => {
        // 小数点第一位で四捨五入
        this.scoreDiffs[i].push(Math.round((score as number) - (latestDataset!.data as number[])[j]));
      });
    });
  }
}
</script>
